import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-payslip-page" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = { class: "header-year-selector" }
const _hoisted_4 = { class: "year-text" }
const _hoisted_5 = { class: "page-content" }
const _hoisted_6 = {
  key: 0,
  class: "payslip-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item-left" }
const _hoisted_9 = { class: "month-badge" }
const _hoisted_10 = { class: "month" }
const _hoisted_11 = {
  key: 0,
  class: "status-badge"
}
const _hoisted_12 = { class: "item-right" }
const _hoisted_13 = { class: "net-pay" }
const _hoisted_14 = { class: "amount" }
const _hoisted_15 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_16 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_17 = { class: "detail-header" }
const _hoisted_18 = { class: "header-title" }
const _hoisted_19 = { class: "year-month" }
const _hoisted_20 = { class: "header-actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_23 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_24 = { class: "section-title info" }
const _hoisted_25 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "detail-section" }
const _hoisted_30 = { class: "section-title pay" }
const _hoisted_31 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_36 = { class: "value" }
const _hoisted_37 = {
  key: 3,
  class: "detail-row"
}
const _hoisted_38 = { class: "value" }
const _hoisted_39 = {
  key: 4,
  class: "detail-row"
}
const _hoisted_40 = { class: "value" }
const _hoisted_41 = {
  key: 5,
  class: "detail-row"
}
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 6,
  class: "detail-row"
}
const _hoisted_44 = { class: "value" }
const _hoisted_45 = {
  key: 7,
  class: "detail-row"
}
const _hoisted_46 = { class: "value" }
const _hoisted_47 = {
  key: 8,
  class: "detail-row"
}
const _hoisted_48 = { class: "value" }
const _hoisted_49 = {
  key: 9,
  class: "detail-row"
}
const _hoisted_50 = { class: "value" }
const _hoisted_51 = { class: "detail-row total" }
const _hoisted_52 = { class: "value" }
const _hoisted_53 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_54 = { class: "section-title deduct" }
const _hoisted_55 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_56 = { class: "value deduct" }
const _hoisted_57 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_58 = { class: "value deduct" }
const _hoisted_59 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_60 = { class: "value deduct" }
const _hoisted_61 = {
  key: 3,
  class: "detail-row"
}
const _hoisted_62 = { class: "value deduct" }
const _hoisted_63 = {
  key: 4,
  class: "detail-row"
}
const _hoisted_64 = { class: "value deduct" }
const _hoisted_65 = {
  key: 5,
  class: "detail-row"
}
const _hoisted_66 = { class: "value deduct" }
const _hoisted_67 = { class: "detail-row total" }
const _hoisted_68 = { class: "value deduct" }
const _hoisted_69 = { class: "net-pay-section" }
const _hoisted_70 = { class: "amount" }
const _hoisted_71 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_72 = { class: "section-title info" }
const _hoisted_73 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_74 = { class: "value" }
const _hoisted_75 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_76 = { class: "value" }
const _hoisted_77 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_78 = { class: "value" }
const _hoisted_79 = { class: "detail-section" }
const _hoisted_80 = { class: "section-title pay" }
const _hoisted_81 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_82 = { class: "value" }
const _hoisted_83 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_84 = { class: "value" }
const _hoisted_85 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_86 = { class: "value" }
const _hoisted_87 = {
  key: 3,
  class: "detail-row"
}
const _hoisted_88 = { class: "value" }
const _hoisted_89 = {
  key: 4,
  class: "detail-row"
}
const _hoisted_90 = { class: "value" }
const _hoisted_91 = {
  key: 5,
  class: "detail-row"
}
const _hoisted_92 = { class: "value" }
const _hoisted_93 = {
  key: 6,
  class: "detail-row"
}
const _hoisted_94 = { class: "value" }
const _hoisted_95 = {
  key: 7,
  class: "detail-row"
}
const _hoisted_96 = { class: "value" }
const _hoisted_97 = {
  key: 8,
  class: "detail-row"
}
const _hoisted_98 = { class: "value" }
const _hoisted_99 = {
  key: 9,
  class: "detail-row"
}
const _hoisted_100 = { class: "value" }
const _hoisted_101 = {
  key: 10,
  class: "detail-row"
}
const _hoisted_102 = { class: "value" }
const _hoisted_103 = {
  key: 11,
  class: "detail-row"
}
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { class: "detail-row total" }
const _hoisted_106 = { class: "value" }
const _hoisted_107 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_108 = { class: "section-title deduct" }
const _hoisted_109 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_110 = { class: "value deduct" }
const _hoisted_111 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_112 = { class: "value deduct" }
const _hoisted_113 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_114 = { class: "value deduct" }
const _hoisted_115 = {
  key: 3,
  class: "detail-row"
}
const _hoisted_116 = { class: "value deduct" }
const _hoisted_117 = {
  key: 4,
  class: "detail-row"
}
const _hoisted_118 = { class: "value deduct" }
const _hoisted_119 = {
  key: 5,
  class: "detail-row"
}
const _hoisted_120 = { class: "value deduct" }
const _hoisted_121 = {
  key: 6,
  class: "detail-row"
}
const _hoisted_122 = { class: "value deduct" }
const _hoisted_123 = {
  key: 7,
  class: "detail-row"
}
const _hoisted_124 = { class: "value deduct" }
const _hoisted_125 = {
  key: 8,
  class: "detail-row"
}
const _hoisted_126 = { class: "value deduct" }
const _hoisted_127 = { class: "detail-row total" }
const _hoisted_128 = { class: "value deduct" }
const _hoisted_129 = { class: "net-pay-section" }
const _hoisted_130 = { class: "amount" }
const _hoisted_131 = {
  key: 2,
  class: "yobo-notice"
}
const _hoisted_132 = {
  key: 2,
  class: "no-data-section"
}
const _hoisted_133 = {
  key: 1,
  class: "detail-loading"
}
const _hoisted_134 = { class: "year-list" }
const _hoisted_135 = ["onClick"]

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpPayslip',
  setup(__props) {

const store = useStore();

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);
const empIdx = computed(() => pwaUser.value?.emp_idx || '');
const sisulCode = computed(() => pwaUser.value?.m_sisul_code || '');
const empBirth = computed(() => pwaUser.value?.emp_birth || '');
const empWorkStartDate = computed(() => pwaUser.value?.emp_in_date || pwaUser.value?.lem_work_start_date || '');

// 상태
const isLoading = ref(false);
const isLoadingDetail = ref(false);
const isDownloading = ref(false);
const selectedYear = ref(new Date().getFullYear());
const payslipHistory = ref<any[]>([]);
const empType = ref<'sabok' | 'yobo'>('yobo');
const showYearPicker = ref(false);
const showDetail = ref(false);
const selectedPayslip = ref<any>(null);
const detailType = ref<'sabok' | 'yobo' | null>(null);
const detailData = ref<any>(null);
const taxData = ref<any>(null);

// 연도 목록 (현재 연도 기준 5년)
const availableYears = computed(() => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, i) => currentYear - i);
});

// 원단위 절삭 함수 (예: 51131 -> 51130)
const truncateToTen = (value: number) => Math.floor(value / 10) * 10;

// 만 나이 계산
const calculateAge = (birthDateStr: string, baseYm: string) => {
  if (!birthDateStr || !baseYm) return 0;
  // YYYYMMDD -> YYYY-MM-DD 변환
  let birthFormatted = birthDateStr;
  if (/^\d{8}$/.test(birthDateStr)) {
    birthFormatted = `${birthDateStr.substring(0, 4)}-${birthDateStr.substring(4, 6)}-${birthDateStr.substring(6, 8)}`;
  }
  const birthDate = new Date(birthFormatted);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth, 0);
  let age = baseDate.getFullYear() - birthDate.getFullYear();
  if (baseDate.getMonth() < birthDate.getMonth() ||
    (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// 근속년수 계산 (연차일수 계산용)
const calculateWorkPeriod = (startDateStr: string, baseYm: string) => {
  if (!startDateStr || !baseYm) return { years: 0, months: 0 };
  // YYYYMMDD -> YYYY-MM-DD 변환
  let startFormatted = startDateStr;
  if (/^\d{8}$/.test(startDateStr)) {
    startFormatted = `${startDateStr.substring(0, 4)}-${startDateStr.substring(4, 6)}-${startDateStr.substring(6, 8)}`;
  }
  const workStartDate = new Date(startFormatted);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth - 1, 1);
  let years = baseDate.getFullYear() - workStartDate.getFullYear();
  let months = baseDate.getMonth() - workStartDate.getMonth();
  if (months < 0) {
    years--;
    months += 12;
  }
  return { years, months };
};

// 연차 일수 계산 (근속년수 기반)
const getAnnualLeaveDays = (startDateStr: string, baseYm: string) => {
  if (!startDateStr || !baseYm) return 11;
  const period = calculateWorkPeriod(startDateStr, baseYm);
  if (period.years === 0 && period.months === 0) return 0;
  const yearLevel = period.years + 1;
  if (yearLevel >= 21) return 25;
  
  const vacationYearOptions = [
    { value: 1, days: 11 }, { value: 2, days: 15 }, { value: 3, days: 15 },
    { value: 4, days: 16 }, { value: 5, days: 16 }, { value: 6, days: 17 },
    { value: 7, days: 17 }, { value: 8, days: 18 }, { value: 9, days: 18 },
    { value: 10, days: 19 }, { value: 11, days: 19 }, { value: 12, days: 20 },
    { value: 13, days: 20 }, { value: 14, days: 21 }, { value: 15, days: 21 },
    { value: 16, days: 22 }, { value: 17, days: 22 }, { value: 18, days: 23 },
    { value: 19, days: 23 }, { value: 20, days: 24 }
  ];
  
  const option = vacationYearOptions.find(opt => opt.value === yearLevel);
  return option ? option.days : 11;
};

// 그룹화된 수급자 데이터
const groupedPatients = computed(() => {
  if (detailType.value !== 'yobo' || !Array.isArray(detailData.value)) return [];
  
  return detailData.value.map((item: any) => ({
    patientName: item.leb_patient_name || item.patient_name || '수급자',
    patientCode: item.leb_patient_code || item.lemi_patient_code || '',
    sugaCode: item.suga_code || item.lemi_suga_code || '',
    sugaName: item.suga_name || '-',
    timePay: parseInt(String(item.time_pay || item.lemi_time_pay || '0').replace(/[^\d]/g, '')) || 0,
    serviceDays: parseInt(item.service_days) || 0,
    sugaHours: parseFloat(item.suga_hours) || 0,
    totalSugaMoney: parseInt(String(item.total_suga_money || '0').replace(/[^\d]/g, '')) || 0,
    lunchTimeCount: parseInt(item.lunch_time_count) || 0
  }));
});

// 가족요양만 있는지 확인
const isFamilyOnly = computed(() => {
  return groupedPatients.value.every((p: any) => (p.sugaName || '').includes('가족'));
});

// 총 점심 횟수
const totalLunchTimeCount = computed(() => {
  return groupedPatients.value.reduce((sum: number, p: any) => sum + (p.lunchTimeCount || 0), 0);
});

// 중증수급자가산 총액 계산
const totalSevereCareAddition = computed(() => {
  if (!Array.isArray(detailData.value)) return 0;
  return detailData.value
    .filter((item: any) => (item.suga_name || '').includes('중증수급자'))
    .reduce((sum: number, item: any) => {
      return sum + (parseInt(String(item.total_suga_money || '0').replace(/[^\d]/g, '')) || 0);
    }, 0);
});

// 요양보호사 급여 계산 (웹 StepThree.vue와 동일한 로직)
const yoboPayroll = computed(() => {
  if (detailType.value !== 'yobo' || !Array.isArray(detailData.value) || detailData.value.length === 0) {
    return null;
  }

  const patients = groupedPatients.value;
  const firstItem = detailData.value[0];
  
  // 설정 데이터
  const settings = {
    applyHealthInsurance: firstItem.lemi_apply_gun === 'Y',
    applyEmploymentInsurance: firstItem.lemi_apply_go === 'Y',
    applyHoliday: firstItem.lemi_apply_holiday_pay === 'Y',
    applyOvertime: firstItem.lemi_apply_overtime_pay === 'Y',
    applyMeal: firstItem.lemi_apply_lunch_pay === 'Y',
    applyRetirement: firstItem.lemi_apply_out_pay === 'Y',
    longServicePay: parseInt(String(firstItem.lemi_long_service_pay || '0').replace(/[^\d]/g, '')) || 0,
    bosuEduPay: parseInt(String(firstItem.lemi_bosu_edu_pay || '0').replace(/[^\d]/g, '')) || 0,
    yeonPay: parseInt(String(firstItem.lemi_yeon_pay || '0').replace(/[^\d]/g, '')) || 0,
    boninPay: parseInt(String(firstItem.lemi_bonin_pay || '0').replace(/[^\d]/g, '')) || 0,
    empEtc: parseInt(String(firstItem.lemi_emp_etc || '0').replace(/[^\d]/g, '')) || 0,
    isBoss: firstItem.lem_isboss === 'Y',
    workStartDate: firstItem.lem_work_start_date || empWorkStartDate.value || ''
  };

  // 총 수가시간, 서비스 횟수 계산
  let totalSugaHours = 0;
  let serviceDays = 0;
  patients.forEach((patient: any) => {
    totalSugaHours += (patient.serviceDays || 0) * (patient.sugaHours || 0);
    serviceDays += patient.serviceDays || 0;
  });

  // 평균 시급 계산 (가중평균)
  let totalWeightedPay = 0;
  let totalHours = 0;
  
  patients.forEach((patient: any) => {
    const timePay = patient.timePay || 0;
    if (timePay > 0 && patient.sugaHours > 0) {
      const sugaHours = (patient.serviceDays || 0) * (patient.sugaHours || 0);
      totalWeightedPay += timePay * sugaHours;
      totalHours += sugaHours;
    }
  });

  const avgTimePay = totalHours > 0 ? Math.round(totalWeightedPay / totalHours) : 0;
  const totalMonthlyPay = totalWeightedPay;
  const longServicePay = settings.longServicePay || 0;
  const bosuEduPay = settings.bosuEduPay || 0;
  const severeCareAddition = totalSevereCareAddition.value;
  
  // 수당 계산 (60시간 이상일 때만)
  const canApplyAllowances = totalSugaHours >= 60;
  const holidayAllowance = settings.applyHoliday && canApplyAllowances ? 
    Math.min(Math.round(avgTimePay * 8 * 1.5), 200000) : 0;
  const overtimeAllowance = settings.applyOvertime && canApplyAllowances ? 
    Math.min(Math.round(avgTimePay * 4 * 1.5), 200000) : 0;
  
  // 기본급 등 계산
  let basicPay = 0;
  let holidayPay = 0;
  let vacationPay = 0;
  let actualMealAllowance = 0;
  
  const baseYm = selectedPayslip.value?.ewi_ym || '';
  
  if (isFamilyOnly.value) {
    basicPay = totalMonthlyPay;
  } else {
    const minWage = taxData.value?.tr_time_pay || 9860;
    if (minWage > 0) {
      basicPay = minWage * totalSugaHours;
      holidayPay = Math.round(basicPay * 0.2);
      
      // 연차일수 계산 (근속년수 기반)
      const annualLeaveDays = getAnnualLeaveDays(settings.workStartDate, baseYm);
      vacationPay = serviceDays > 0 ? Math.round((minWage * totalSugaHours / serviceDays) * annualLeaveDays / 12) : 0;
      
      // 식대 계산
      if (settings.applyMeal && totalLunchTimeCount.value > 0) {
        const requestedMealAllowance = Math.min(totalLunchTimeCount.value * 20000, 200000);
        const currentBasicTotal = basicPay + holidayPay + vacationPay;
        const remainingAmount = Math.max(0, totalMonthlyPay - currentBasicTotal);
        const availableAmount = Math.min(requestedMealAllowance, remainingAmount);
        const roundedAmount = Math.floor(availableAmount / 100) * 100;
        if (roundedAmount >= 5000) {
          actualMealAllowance = roundedAmount;
        }
      }
      
      const currentTotal = basicPay + holidayPay + vacationPay + actualMealAllowance;
      if (currentTotal < totalMonthlyPay) {
        vacationPay += (totalMonthlyPay - currentTotal);
      }
    } else {
      basicPay = totalMonthlyPay;
    }
  }
  
  const basicTotal = isFamilyOnly.value ? totalMonthlyPay : (basicPay + holidayPay + vacationPay + actualMealAllowance);
  const totalPay = basicTotal + longServicePay + bosuEduPay + severeCareAddition + holidayAllowance + overtimeAllowance;
  
  // 비과세 처리
  const isSalaryUnder2_1M = basicTotal <= 2100000;
  
  let nonTaxableHoliday = 0;
  let nonTaxableOvertime = 0;
  
  if (canApplyAllowances && isSalaryUnder2_1M) {
    const totalOvertimeHolidayAllowance = holidayAllowance + overtimeAllowance;
    
    if (totalOvertimeHolidayAllowance <= 200000) {
      nonTaxableHoliday = holidayAllowance;
      nonTaxableOvertime = overtimeAllowance;
    } else {
      const nonTaxableRatio = 200000 / totalOvertimeHolidayAllowance;
      nonTaxableHoliday = Math.round(holidayAllowance * nonTaxableRatio);
      nonTaxableOvertime = Math.round(overtimeAllowance * nonTaxableRatio);
    }
  }
  
  const nonTaxableMeal = Math.min(actualMealAllowance, 200000);
  const taxableHoliday = holidayAllowance - nonTaxableHoliday;
  const taxableOvertime = overtimeAllowance - nonTaxableOvertime;
  const taxableAmount = basicTotal + longServicePay + bosuEduPay + taxableHoliday + taxableOvertime - actualMealAllowance + (actualMealAllowance - nonTaxableMeal);
  
  // 보험 요율
  const insuranceRates = {
    nationalPension: taxData.value?.tr_yeon || 0.045,
    healthInsurance: taxData.value?.tr_gun || 0.03545,
    longTermCare: taxData.value?.tr_jang || 0.1295,
    employmentInsurance: taxData.value?.tr_go || 0.009
  };

  const age = calculateAge(empBirth.value, baseYm);
  
  const yeonPayAmount = settings.yeonPay || 0;
  const canApplyPension = age < 60 && yeonPayAmount > 0;
  const canApplyEmployment = age < 65 && settings.applyEmploymentInsurance && !settings.isBoss;

  // 근로자 공제 (원단위 절삭 적용)
  const employeeDeductions = {
    nationalPension: canApplyPension ? truncateToTen(yeonPayAmount) : 0,
    healthInsurance: settings.applyHealthInsurance && canApplyAllowances ? truncateToTen(taxableAmount * insuranceRates.healthInsurance) : 0,
    longTermCare: 0,
    employmentInsurance: canApplyEmployment && canApplyAllowances ? truncateToTen(taxableAmount * insuranceRates.employmentInsurance) : 0,
    incomeTax: canApplyAllowances ? truncateToTen(taxableAmount * 0.03) : 0,
    localTax: 0
  };
  
  employeeDeductions.longTermCare = truncateToTen(employeeDeductions.healthInsurance * insuranceRates.longTermCare);
  employeeDeductions.localTax = truncateToTen(employeeDeductions.incomeTax * 0.1);

  // 추가 공제
  const boninPayAmount = settings.boninPay || 0;
  const empEtcAmount = settings.empEtc || 0;

  const totalEmployeeDeduction = 
    employeeDeductions.nationalPension + employeeDeductions.healthInsurance +
    employeeDeductions.longTermCare + employeeDeductions.employmentInsurance +
    employeeDeductions.incomeTax + employeeDeductions.localTax +
    boninPayAmount + empEtcAmount;

  const netPay = totalPay - totalEmployeeDeduction;

  return {
    basicPay,
    holidayPay,
    vacationPay,
    mealAllowance: actualMealAllowance,
    basicTotal,
    longServicePay,
    bosuEduPay,
    severeCareAddition,
    holidayAllowance,
    overtimeAllowance,
    totalPay,
    employeeDeductions,
    boninPayAmount,
    empEtcAmount,
    totalEmployeeDeduction,
    netPay,
    suga_hours: Math.round(totalSugaHours * 10) / 10,
    service_days: serviceDays
  };
});

// 연도 변경
const changeYear = (delta: number) => {
  const newYear = selectedYear.value + delta;
  const currentYear = new Date().getFullYear();
  if (newYear >= currentYear - 4 && newYear <= currentYear) {
    selectedYear.value = newYear;
  }
};

// 연도 선택
const selectYear = (year: number) => {
  selectedYear.value = year;
  showYearPicker.value = false;
};

// 월 추출
const getMonth = (ym: string): number => {
  if (!ym) return 0;
  return parseInt(ym.substring(4, 6), 10);
};

// 금액 포맷
const formatCurrency = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) return '0';
  const numValue = typeof value === 'string' ? parseInt(value.replace(/[^\d]/g, ''), 10) : value;
  if (isNaN(numValue)) return '0';
  return numValue.toLocaleString('ko-KR');
};

// 세금 데이터 조회
const fetchTaxData = async (year: string) => {
  try {
    const response = await axios.get(`/api/calc/tax/${year}`, { withCredentials: true });
    if (response.data.success) {
      taxData.value = response.data.data.taxRate;
    }
  } catch (error) {
    console.error('세금 데이터 조회 오류:', error);
  }
};

// 급여 내역 조회
const fetchPayslipHistory = async () => {
  if (!empIdx.value || !sisulCode.value) {
    console.warn('사원 정보가 없습니다.');
    return;
  }

  isLoading.value = true;
  try {
    const response = await axios.get(
      `/api/emp/payslip-history/${empIdx.value}/${sisulCode.value}/${selectedYear.value}`,
      { withCredentials: true }
    );

    if (response.data.success) {
      // 마감(확정)된 데이터만 필터링하여 표시
      const allData = response.data.data || [];
      payslipHistory.value = allData.filter((item: any) => item.is_closed === 'y');
      empType.value = response.data.type || 'yobo';
    } else {
      payslipHistory.value = [];
    }
  } catch (error) {
    console.error('급여 내역 조회 오류:', error);
    payslipHistory.value = [];
  } finally {
    isLoading.value = false;
  }
};

// 급여 상세 조회
const openPayslipDetail = async (item: any) => {
  selectedPayslip.value = item;
  showDetail.value = true;
  isLoadingDetail.value = true;
  detailData.value = null;
  detailType.value = null;

  // 세금 데이터 먼저 조회
  const year = item.ewi_ym.substring(0, 4);
  await fetchTaxData(year);

  try {
    const response = await axios.get(
      `/api/emp/payslip/${empIdx.value}/${sisulCode.value}/${item.ewi_ym}`,
      { withCredentials: true }
    );

    if (response.data.success) {
      detailType.value = response.data.type;
      detailData.value = response.data.data;
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '급여 상세 정보를 불러올 수 없습니다.',
        color: 'error'
      });
    }
  } catch (error) {
    console.error('급여 상세 조회 오류:', error);
    store.commit('showSnackbar', {
      text: '급여 상세 정보 조회 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isLoadingDetail.value = false;
  }
};

// 급여명세서 다운로드
const downloadPayslip = async () => {
  if (isDownloading.value || !selectedPayslip.value) return;
  
  isDownloading.value = true;
  try {
    const yearMonth = selectedPayslip.value.ewi_ym;
    const empName = pwaUser.value?.emp_name || '사원';
    
    store.commit('showSnackbar', {
      text: '급여명세서 다운로드 기능은 준비 중입니다.',
      color: 'info'
    });
  } catch (error) {
    console.error('급여명세서 다운로드 오류:', error);
    store.commit('showSnackbar', {
      text: '급여명세서 다운로드 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isDownloading.value = false;
  }
};

// 연도 변경 시 데이터 재조회
watch(selectedYear, () => {
  fetchPayslipHistory();
});

onMounted(() => {
  fetchPayslipHistory();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header-title" }, "급여명세서", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "year-nav-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeYear(-1)))
        }, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(selectedYear.value) + "년", 1),
        _createElementVNode("button", {
          class: "year-nav-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeYear(1)))
        }, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payslipHistory.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.ewi_ym,
                class: _normalizeClass(["payslip-item", { 'closed': item.is_closed === 'y' }]),
                onClick: ($event: any) => (openPayslipDetail(item))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(getMonth(item.ewi_ym)), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "unit" }, "월", -1))
                  ]),
                  (item.is_closed === 'y')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "white"
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-check", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[10] || (_cache[10] = _createTextVNode(" 확정 ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(formatCurrency(item.ewi_net_pay)) + "원", 1)
                  ]),
                  _createVNode(_component_v_icon, {
                    size: "20",
                    color: "#9ca3af"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 10, _hoisted_7))
            }), 128)),
            (payslipHistory.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_v_icon, {
                    size: "48",
                    color: "#d1d5db"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("mdi-file-document-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 급여 내역이 없습니다.", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "#059669",
              size: "40"
            }),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "급여 내역을 불러오는 중...", -1))
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: showDetail.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDetail).value = $event)),
        "max-width": "450"
      }, {
        default: _withCtx(() => [
          (selectedPayslip.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "payslip-detail-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(selectedYear.value) + "년 " + _toDisplayString(getMonth(selectedPayslip.value.ewi_ym)) + "월", 1),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "title" }, "급여명세서", -1))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        class: "download-btn",
                        onClick: downloadPayslip,
                        disabled: isDownloading.value
                      }, [
                        _createVNode(_component_v_icon, { size: "20" }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-download", -1)
                          ]))]),
                          _: 1
                        })
                      ], 8, _hoisted_21),
                      _createElementVNode("button", {
                        class: "close-btn",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetail.value = false))
                      }, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  (!isLoadingDetail.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (detailType.value === 'sabok' && detailData.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (detailData.value.ewi_service_days || detailData.value.ewi_suga_hours)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("h3", _hoisted_24, [
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: "#2563eb"
                                      }, {
                                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                          _createTextVNode("mdi-clock-outline", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[19] || (_cache[19] = _createTextVNode(" 근무 정보 ", -1))
                                    ]),
                                    (detailData.value.ewi_service_days)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "근무일수", -1)),
                                          _createElementVNode("span", _hoisted_26, _toDisplayString(detailData.value.ewi_service_days) + "일", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (detailData.value.ewi_suga_hours)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "근무시간", -1)),
                                          _createElementVNode("span", _hoisted_28, _toDisplayString(detailData.value.ewi_suga_hours) + "시간", 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("h3", _hoisted_30, [
                                  _createVNode(_component_v_icon, {
                                    size: "18",
                                    color: "#059669"
                                  }, {
                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                      _createTextVNode("mdi-plus-circle", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[23] || (_cache[23] = _createTextVNode(" 지급 내역 ", -1))
                                ]),
                                (parseInt(detailData.value.ewi_monthly_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "월 기본급", -1)),
                                      _createElementVNode("span", _hoisted_32, _toDisplayString(formatCurrency(detailData.value.ewi_monthly_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_weekly_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "주휴수당", -1)),
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(formatCurrency(detailData.value.ewi_weekly_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_annual_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "연차수당", -1)),
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(formatCurrency(detailData.value.ewi_annual_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_holiday_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "휴일수당", -1)),
                                      _createElementVNode("span", _hoisted_38, _toDisplayString(formatCurrency(detailData.value.ewi_holiday_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_overtime_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "연장수당", -1)),
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(formatCurrency(detailData.value.ewi_overtime_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_night_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "야간수당", -1)),
                                      _createElementVNode("span", _hoisted_42, _toDisplayString(formatCurrency(detailData.value.ewi_night_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_meal_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "식대", -1)),
                                      _createElementVNode("span", _hoisted_44, _toDisplayString(formatCurrency(detailData.value.ewi_meal_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_long_service_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "장기근속수당", -1)),
                                      _createElementVNode("span", _hoisted_46, _toDisplayString(formatCurrency(detailData.value.ewi_long_service_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_bosu_edu_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "보수교육비", -1)),
                                      _createElementVNode("span", _hoisted_48, _toDisplayString(formatCurrency(detailData.value.ewi_bosu_edu_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(detailData.value.ewi_other_pay || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "기타수당", -1)),
                                      _createElementVNode("span", _hoisted_50, _toDisplayString(formatCurrency(detailData.value.ewi_other_pay)) + "원", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_51, [
                                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "총 지급액", -1)),
                                  _createElementVNode("span", _hoisted_52, _toDisplayString(formatCurrency(detailData.value.ewi_total_pay)) + "원", 1)
                                ])
                              ]),
                              (parseInt(detailData.value.ewi_emp_total_deduction || 0) > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    _createElementVNode("h3", _hoisted_54, [
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: "#dc2626"
                                      }, {
                                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                          _createTextVNode("mdi-minus-circle", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[36] || (_cache[36] = _createTextVNode(" 공제 내역 ", -1))
                                    ]),
                                    (parseInt(detailData.value.ewi_emp_yeon || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "국민연금", -1)),
                                          _createElementVNode("span", _hoisted_56, _toDisplayString(formatCurrency(detailData.value.ewi_emp_yeon)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (parseInt(detailData.value.ewi_emp_gun || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "건강보험", -1)),
                                          _createElementVNode("span", _hoisted_58, _toDisplayString(formatCurrency(detailData.value.ewi_emp_gun)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (parseInt(detailData.value.ewi_emp_jang || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "장기요양보험", -1)),
                                          _createElementVNode("span", _hoisted_60, _toDisplayString(formatCurrency(detailData.value.ewi_emp_jang)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (parseInt(detailData.value.ewi_emp_go || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "고용보험", -1)),
                                          _createElementVNode("span", _hoisted_62, _toDisplayString(formatCurrency(detailData.value.ewi_emp_go)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (parseInt(detailData.value.ewi_emp_so || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "소득세", -1)),
                                          _createElementVNode("span", _hoisted_64, _toDisplayString(formatCurrency(detailData.value.ewi_emp_so)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (parseInt(detailData.value.ewi_emp_ji || 0) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "지방소득세", -1)),
                                          _createElementVNode("span", _hoisted_66, _toDisplayString(formatCurrency(detailData.value.ewi_emp_ji)) + "원", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_67, [
                                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "총 공제액", -1)),
                                      _createElementVNode("span", _hoisted_68, _toDisplayString(formatCurrency(detailData.value.ewi_emp_total_deduction)) + "원", 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_69, [
                                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                                _createElementVNode("span", _hoisted_70, _toDisplayString(formatCurrency(detailData.value.ewi_net_pay)) + "원", 1)
                              ])
                            ], 64))
                          : (detailType.value === 'yobo' && detailData.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (detailData.value.ewi_service_days || detailData.value.ewi_suga_hours)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                      _createElementVNode("h3", _hoisted_72, [
                                        _createVNode(_component_v_icon, {
                                          size: "18",
                                          color: "#2563eb"
                                        }, {
                                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                            _createTextVNode("mdi-clock-outline", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _cache[46] || (_cache[46] = _createTextVNode(" 근무 정보 ", -1))
                                      ]),
                                      (detailData.value.ewi_service_days)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "label" }, "서비스 횟수", -1)),
                                            _createElementVNode("span", _hoisted_74, _toDisplayString(detailData.value.ewi_service_days) + "회", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (detailData.value.ewi_suga_hours)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                            _cache[48] || (_cache[48] = _createElementVNode("span", { class: "label" }, "수가시간", -1)),
                                            _createElementVNode("span", _hoisted_76, _toDisplayString(detailData.value.ewi_suga_hours) + "시간", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (detailData.value.ewi_avg_time_pay > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "label" }, "평균시급", -1)),
                                            _createElementVNode("span", _hoisted_78, _toDisplayString(formatCurrency(detailData.value.ewi_avg_time_pay)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("h3", _hoisted_80, [
                                    _createVNode(_component_v_icon, {
                                      size: "18",
                                      color: "#059669"
                                    }, {
                                      default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                        _createTextVNode("mdi-plus-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[51] || (_cache[51] = _createTextVNode(" 지급 내역 ", -1))
                                  ]),
                                  (parseInt(detailData.value.ewi_basic_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "label" }, "기본급", -1)),
                                        _createElementVNode("span", _hoisted_82, _toDisplayString(formatCurrency(detailData.value.ewi_basic_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_weekly_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "label" }, "주휴수당", -1)),
                                        _createElementVNode("span", _hoisted_84, _toDisplayString(formatCurrency(detailData.value.ewi_weekly_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_annual_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                        _cache[54] || (_cache[54] = _createElementVNode("span", { class: "label" }, "연차수당", -1)),
                                        _createElementVNode("span", _hoisted_86, _toDisplayString(formatCurrency(detailData.value.ewi_annual_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_meal_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "label" }, "식대", -1)),
                                        _createElementVNode("span", _hoisted_88, _toDisplayString(formatCurrency(detailData.value.ewi_meal_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_long_service_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                        _cache[56] || (_cache[56] = _createElementVNode("span", { class: "label" }, "장기근속수당", -1)),
                                        _createElementVNode("span", _hoisted_90, _toDisplayString(formatCurrency(detailData.value.ewi_long_service_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_bosu_edu_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                        _cache[57] || (_cache[57] = _createElementVNode("span", { class: "label" }, "보수교육비", -1)),
                                        _createElementVNode("span", _hoisted_92, _toDisplayString(formatCurrency(detailData.value.ewi_bosu_edu_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_severe_care_addition || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                        _cache[58] || (_cache[58] = _createElementVNode("span", { class: "label" }, "중증수급자가산", -1)),
                                        _createElementVNode("span", _hoisted_94, _toDisplayString(formatCurrency(detailData.value.ewi_severe_care_addition)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_holiday_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "label" }, "휴일수당", -1)),
                                        _createElementVNode("span", _hoisted_96, _toDisplayString(formatCurrency(detailData.value.ewi_holiday_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_overtime_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "label" }, "연장수당", -1)),
                                        _createElementVNode("span", _hoisted_98, _toDisplayString(formatCurrency(detailData.value.ewi_overtime_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_night_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "label" }, "야간수당", -1)),
                                        _createElementVNode("span", _hoisted_100, _toDisplayString(formatCurrency(detailData.value.ewi_night_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_labor_day_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                        _cache[62] || (_cache[62] = _createElementVNode("span", { class: "label" }, "근로자의날수당", -1)),
                                        _createElementVNode("span", _hoisted_102, _toDisplayString(formatCurrency(detailData.value.ewi_labor_day_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (parseInt(detailData.value.ewi_other_pay || 0) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "label" }, "기타수당", -1)),
                                        _createElementVNode("span", _hoisted_104, _toDisplayString(formatCurrency(detailData.value.ewi_other_pay)) + "원", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_105, [
                                    _cache[64] || (_cache[64] = _createElementVNode("span", { class: "label" }, "총 지급액", -1)),
                                    _createElementVNode("span", _hoisted_106, _toDisplayString(formatCurrency(detailData.value.ewi_total_pay)) + "원", 1)
                                  ])
                                ]),
                                (parseInt(detailData.value.ewi_emp_total_deduction || 0) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                      _createElementVNode("h3", _hoisted_108, [
                                        _createVNode(_component_v_icon, {
                                          size: "18",
                                          color: "#dc2626"
                                        }, {
                                          default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                            _createTextVNode("mdi-minus-circle", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _cache[66] || (_cache[66] = _createTextVNode(" 공제 내역 ", -1))
                                      ]),
                                      (parseInt(detailData.value.ewi_emp_yeon || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                            _cache[67] || (_cache[67] = _createElementVNode("span", { class: "label" }, "국민연금", -1)),
                                            _createElementVNode("span", _hoisted_110, _toDisplayString(formatCurrency(detailData.value.ewi_emp_yeon)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_gun || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                            _cache[68] || (_cache[68] = _createElementVNode("span", { class: "label" }, "건강보험", -1)),
                                            _createElementVNode("span", _hoisted_112, _toDisplayString(formatCurrency(detailData.value.ewi_emp_gun)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_jang || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                            _cache[69] || (_cache[69] = _createElementVNode("span", { class: "label" }, "장기요양보험", -1)),
                                            _createElementVNode("span", _hoisted_114, _toDisplayString(formatCurrency(detailData.value.ewi_emp_jang)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_go || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                            _cache[70] || (_cache[70] = _createElementVNode("span", { class: "label" }, "고용보험", -1)),
                                            _createElementVNode("span", _hoisted_116, _toDisplayString(formatCurrency(detailData.value.ewi_emp_go)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_so || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                            _cache[71] || (_cache[71] = _createElementVNode("span", { class: "label" }, "소득세", -1)),
                                            _createElementVNode("span", _hoisted_118, _toDisplayString(formatCurrency(detailData.value.ewi_emp_so)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_ji || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                            _cache[72] || (_cache[72] = _createElementVNode("span", { class: "label" }, "지방소득세", -1)),
                                            _createElementVNode("span", _hoisted_120, _toDisplayString(formatCurrency(detailData.value.ewi_emp_ji)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_support_deduction || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                            _cache[73] || (_cache[73] = _createElementVNode("span", { class: "label" }, "지원공제", -1)),
                                            _createElementVNode("span", _hoisted_122, _toDisplayString(formatCurrency(detailData.value.ewi_emp_support_deduction)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_bonin_pay || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                            _cache[74] || (_cache[74] = _createElementVNode("span", { class: "label" }, "본인부담금공제", -1)),
                                            _createElementVNode("span", _hoisted_124, _toDisplayString(formatCurrency(detailData.value.ewi_emp_bonin_pay)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (parseInt(detailData.value.ewi_emp_etc || 0) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                            _cache[75] || (_cache[75] = _createElementVNode("span", { class: "label" }, "기타공제", -1)),
                                            _createElementVNode("span", _hoisted_126, _toDisplayString(formatCurrency(detailData.value.ewi_emp_etc)) + "원", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_127, [
                                        _cache[76] || (_cache[76] = _createElementVNode("span", { class: "label" }, "총 공제액", -1)),
                                        _createElementVNode("span", _hoisted_128, _toDisplayString(formatCurrency(detailData.value.ewi_emp_total_deduction)) + "원", 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_129, [
                                  _cache[77] || (_cache[77] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                                  _createElementVNode("span", _hoisted_130, _toDisplayString(formatCurrency(detailData.value.ewi_net_pay)) + "원", 1)
                                ]),
                                (parseFloat(detailData.value.ewi_suga_hours || 0) < 60)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        color: "#d97706"
                                      }, {
                                        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                          _createTextVNode("mdi-alert-circle-outline", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[79] || (_cache[79] = _createElementVNode("span", null, "60시간 미만 근무로 4대보험 공제가 적용되지 않습니다.", -1))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                _createVNode(_component_v_icon, {
                                  size: "48",
                                  color: "#d1d5db"
                                }, {
                                  default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                    _createTextVNode("mdi-file-document-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[81] || (_cache[81] = _createElementVNode("p", null, "해당 월 급여 상세 정보가 없습니다.", -1))
                              ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_133, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "#059669",
                          size: "32"
                        }),
                        _cache[82] || (_cache[82] = _createElementVNode("p", null, "상세 정보를 불러오는 중...", -1))
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showYearPicker.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showYearPicker).value = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                _createTextVNode("연도 선택", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_134, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: year,
                      class: _normalizeClass(["year-item", { active: selectedYear.value === year }]),
                      onClick: ($event: any) => (selectYear(year))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(year) + "년", 1),
                      (selectedYear.value === year)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "20",
                            color: "#059669"
                          }, {
                            default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_135))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})